import PropTypes from "prop-types";
import useWindowSize from "../../hooks/useWindowSize";
import Color from "color";
import { useMediaQuery } from "react-responsive";
import ImageOrVideo from "../ImageOrVideo";
import ProductLink from "../ProductLink";

const StoryImage = ({
  image,
  caption,
  heading,
  product_link,
  menubarOffset = 0
}) => {
  const hasProductLink = product_link?._id !== undefined;
  const isSmall = useMediaQuery({ maxWidth: 575.98 });
  const winDim = useWindowSize();
  const wpHeight = winDim.innerHeight - menubarOffset;
  if (!image.width) image.width = 1920;
  if (!image.height) image.height = 1080;
  const imageIsWide = image.width / image.height >= 1.4;
  const windowIsNotUltraWide = winDim.innerWidth / wpHeight <= 1.9;
  const imageIsWiderThanWindow =
    image.width / image.height >= winDim.innerWidth / wpHeight;
  const imageDims = imageIsWiderThanWindow
    ? {
        width: winDim.innerWidth,
        height: image.height * (winDim.innerWidth / image.width)
      }
    : {
        height: wpHeight,
        width:
          imageIsWide && windowIsNotUltraWide
            ? winDim.innerWidth
            : image.width * (wpHeight / image.height)
      };

  return (
    <div
      className="story-image-container"
      style={{
        position: "relative",
        /*height: "calc(100vh - var(--menu-height) - var(--padding-top))",*/
        height: "auto",
        maxHeight: "100vh",
        width: "100%"
      }}
    >
      <div
        style={{
          display: "block",
          position: "relative",
          backgroundColor: image.colors && image.colors[0],
          /*height: "calc(100vh - var(--menu-height) - var(--padding-top))",*/
          height: "auto",
          maxHeight: "100vh",
          width: "100%"
        }}
        className="story-image"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          style={{ position: "absolute", top: 0, left: 0, bottom: 0, right: 0 }}
        >
          <pattern
            id="p1"
            viewBox="0 0 6 6"
            width="200"
            height="200"
            patternUnits="userSpaceOnUse"
            patternTransform="rotate(135)"
            stroke={image.colors ? image.colors[1] : "#999"}
            strokeOpacity="0.1"
            strokeWidth="0.05"
            strokeMiterlimit="40"
          >
            <polygon
              points="0 0 0 3 0 4 3 4 3 6 4 6 4 3 4 2 1 2 1 0 0 0"
              fill="none"
            />
            <polyline points="4 3 1 3 1 2" fill="none" />
            <line x1="0" y1="3" x2="1" y2="3" />
            <line x1="3" y1="4" x2="3" y2="3" />
            <polyline points="2 6 2 5 2 4" fill="none" />
            <line x1="0" y1="5" x2="2" y2="5" />
            <polyline points="0 6 1 6 1 5" fill="none" />
            <line x1="6" y1="6" x2="4" y2="6" />
            <line x1="4" y1="5" x2="6" y2="5" />
            <polyline points="2 0 2 1 2 2" fill="none" />
            <polyline points="2 1 6 1 6 0 3 0 3 1" fill="none" />
            <polyline points="6 1 6 4 5 4" fill="none" />
            <polyline points="5 5 5 4 5 1" fill="none" />
            <line x1="4" y1="2" x2="5" y2="2" />
          </pattern>
          <rect fill="url(#p1)" width="100%" height="100%"></rect>
        </svg>
        <ImageOrVideo
          image={image}
          containImage
          centerImage
          style={{
            position: "relative",
            /*...(!imageIsWiderThanWindow && {
              position: "relative",
              margin: "0 auto"
            }),*/
            height: imageDims.height + "px",
            /*width: imageDims.width + "px",
            height: "calc(100vh - var(--menu-height) - var(--padding-top))",*/
            width: "100%"
          }}
        />
        {heading && (
          <div
            style={{
              display: "flex",
              position: "absolute",
              top: 0,
              bottom: isSmall ? 0 : "40%",
              left: 0,
              right: 0,
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <h1
              style={{
                color: "#fff",
                textShadow: "1px 1px 1rem rgba(0, 0, 0, 0.7)",
                textAlign: "center"
              }}
            >
              {heading}
            </h1>
          </div>
        )}
        {(caption || hasProductLink) && (
          <div
            className="story-image-caption"
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              display: "flex",
              justifyContent: "center"
            }}
          >
            <p
              style={{
                background: Color(image.colors[0])
                  .saturate(2)
                  .alpha(0.4)
                  .string(),
                padding: isSmall ? "0.7rem 2rem 1rem" : "1rem 4rem 2rem",
                maxWidth: "75rem",
                width: imageDims.width + "px",
                margin: "0 auto",
                fontSize: isSmall ? "0.8em" : "1em"
              }}
            >
              {caption}
              {hasProductLink && (
                <span
                  style={{
                    marginLeft: caption ? "1rem" : 0,
                    whiteSpace: "nowrap"
                  }}
                >
                  <ProductLink
                    showPrefix
                    id={product_link._id}
                    style={{
                      color: "#000",
                      fontWeight: "500"
                    }}
                  />
                </span>
              )}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

StoryImage.propTypes = {
  image: PropTypes.object.isRequired
};

export default StoryImage;
